import ImageItem from '@/common/interfaces/ImageItem';
import PhotographyViewModel from '@/common/interfaces/modules/PhotographyInfo';
import LocationInfoViewModel from '@/common/interfaces/modules/LocationInfo';
import VideoItem from '@/common/interfaces/VideoItem';
import LinkItem from '@/common/interfaces/LinkItem';
import {CtaItemType} from "@/components/CtaItem/CtaItem";
import { PageModule } from '../../store/modules/modulesLoadModule';

export interface HeroLargeViewModel {
  Title: string;
  Image: ImageItem;
  Video?: VideoItem;
  Cta?: LinkItem;
  ScrollDownTitle?: string;
  ScrollToLink?: string;
  Latitude?: string;
  Longitude?: string;
  Locations?: string[];
  FullVideo?: VideoItem;
  LocationInfo?: LocationInfoViewModel
  PhotographyInfo?: PhotographyViewModel;
  CtaItems?: CtaItemType[];
}

export const convert = (data: HeroLargeViewModel): HeroLargeViewModel => {
  if (data.Video && data.Video.Url && data.Video.Poster === '') data.Video.Poster = data.Image.Url;

  return data;
};
